import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BAIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BA" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0h16.2v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M5 0h10.2v12L5 0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="m3.554 1.397-.588.309.112-.655-.475-.463.657-.096.294-.595.294.595.657.096-.476.463.113.655-.588-.309ZM5.297 3.537l-.588.31.113-.655-.476-.464.657-.095.294-.596.294.596.657.095-.475.464.112.654-.588-.309ZM6.932 5.62l-.588.308.112-.654-.475-.464.657-.095.294-.596.294.596.657.095-.476.464.112.654-.587-.309ZM8.533 7.615l-.588.309.112-.655-.475-.463.657-.096.294-.595.293.595.658.096-.476.463.112.655-.587-.31ZM10.257 9.668l-.588.31.113-.655-.476-.464.657-.095.294-.596.294.596.657.095-.475.464.112.654-.588-.309ZM12.163 11.656l-.587.309.112-.655-.476-.463.657-.096.294-.595.294.595.657.096-.475.463.112.655-.588-.31Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
